import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { inject, injectable } from "inversify";

@injectable()
export class ValidateTemplateSchemaUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}

    async execute(jsonSchema: any): Promise<any> {
        return this.budgetRepository.validateTemplateSchema(jsonSchema);
    }
}
